module.exports = __webpack_public_path__ + "img/icon-plant-3.38dab232.svg";